var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.value,
        label: "他社からのスカウト受け取り数",
        half: "",
      },
    },
    [
      _c("div", { staticClass: "boss-layout boss-layout-start" }, [
        _c("div", [
          _c(
            "select",
            {
              staticClass: "boss-input-select",
              attrs: { "data-test": "select-changed-jobs" },
              domProps: { value: _vm.value },
              on: {
                change: function ($event) {
                  return _vm.$emit("input", $event.target.value || null)
                },
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v("\n          指定なし\n        "),
              ]),
              _vm._v(" "),
              _vm._l(_vm.options, function (option) {
                return _c(
                  "option",
                  {
                    key: option.id,
                    attrs: { "data-test": "option-" + option.id },
                    domProps: { value: option.value },
                  },
                  [_vm._v("\n          " + _vm._s(option.name) + "\n        ")]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "boss-annotation-text" }, [
            _vm._v(
              "\n        ※7日以内にスカウトを受けた企業数で絞り込みます。\n      "
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }